import React from "react";
import { Eye, EyeOff } from "lucide-react";

// Pilot-training safety: a visible "Internal data visible" badge when the
// current context shows margins / cost / internal pricing. Pulses red so
// nobody accidentally shares the screen on a customer call without noticing.
// Hidden entirely for customer / carrier sessions (their UI never shows
// internal data anyway).
export const InternalDataIndicator = ({ viewTier }) => {
  if (viewTier !== "internal") {
    // Customer / carrier tier — render the muted "redacted" form. Keeps the
    // header alignment consistent and gives a positive signal that internal
    // data is hidden.
    return (
      <div
        className="flex items-center gap-1.5 rounded-full"
        style={{
          padding: "3px 8px",
          background: "rgba(120,128,148,0.10)",
          border: "1px solid rgba(120,128,148,0.30)",
          color: "#9aa1b3",
          fontFamily: "DM Mono, monospace",
          fontSize: 9,
          letterSpacing: "1.2px",
          fontWeight: 600,
        }}
        data-testid="internal-data-indicator"
        data-state="redacted"
        title="This session has internal pricing redacted (customer/carrier view)"
      >
        <EyeOff size={10} />
        <span className="hidden md:inline">REDACTED</span>
      </div>
    );
  }
  return (
    <div
      className="flex items-center gap-1.5 rounded-full pulse-warn"
      style={{
        padding: "3px 8px",
        background: "rgba(226,75,74,0.10)",
        border: "1px solid rgba(226,75,74,0.45)",
        color: "#ff9a98",
        fontFamily: "DM Mono, monospace",
        fontSize: 9,
        letterSpacing: "1.2px",
        fontWeight: 700,
      }}
      data-testid="internal-data-indicator"
      data-state="internal"
      title="Internal pricing / cost / margin visible — do not screen-share without filtering"
    >
      <Eye size={10} />
      <span className="hidden md:inline">INTERNAL VISIBLE</span>
    </div>
  );
};

export default InternalDataIndicator;
